"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelectField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const LanguageSelect_1 = require("../../global/LanguageSelect");
const LanguageSelectField = ({ name, label, rules, listName, getFieldValue, listFieldName, ...otherProps }) => {
    const hasListName = typeof listName === 'number' || typeof listName === 'string';
    const fieldName = hasListName ? [listName, name] : name;
    const filterRemainingLanguages = (translatedLanguage) => {
        if (!listFieldName || !hasListName) {
            return translatedLanguage;
        }
        const usedLanguages = getFieldValue(listFieldName);
        const actualLanguage = getFieldValue([listFieldName, listName]);
        const languagesToFilter = usedLanguages.filter(language => language !== actualLanguage && language);
        if (!languagesToFilter.some(({ languageCode }) => translatedLanguage.code === languageCode)) {
            return translatedLanguage;
        }
    };
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: fieldName, label: label, rules: rules, children: (0, jsx_runtime_1.jsx)(LanguageSelect_1.LanguageSelect, { filterRemainingLanguages: filterRemainingLanguages, ...otherProps }) }));
};
exports.LanguageSelectField = LanguageSelectField;
